import React from 'react'
import { Table } from 'components'
import RemoveIcon from 'components/atoms/Icons/Controls/Close'
import { TSegmentPortfolioRow } from '../../types'
import styles from './SegmentForm.module.scss'

interface SegmentFormPortfoliosTableProps {
  data: TSegmentPortfolioRow[]
  onRemove: (id: string) => void
}

const SegmentFormPortfoliosTable = ({ data, onRemove }: SegmentFormPortfoliosTableProps): React.ReactElement => {
  return (
    <>
      <Table>
        <Table.Head>
          <Table.Row>
            <Table.Cell head>Property Address</Table.Cell>
            <Table.Cell head>Lease Details</Table.Cell>
            <Table.Cell head>&nbsp;</Table.Cell>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {data.map(({ id, propertyAddress, leaseDetails }) => (
            <Table.Row key={id}>
              <Table.Cell>{propertyAddress.mainText}</Table.Cell>
              <Table.Cell>{leaseDetails.term}</Table.Cell>
              <Table.Cell className={styles['action-cell']}>
                <button className={styles['remove-button']} type="button" onClick={() => onRemove(id)}>
                  <RemoveIcon />
                </button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  )
}

export default SegmentFormPortfoliosTable
